<template>
  <div id="upload">
    <el-form label-position="left" class="m-4 text-left">
      <el-form-item label-width="25%" size="mini">
        <template slot="label">
          <i class="fa fa-fw fa-paperclip"></i>
          附件
        </template>
        <el-upload
          class="upload-demo"
          :action="upFileUrl"
          :headers="header"
          :data="param"
          :on-progress="handleProcess"
          :on-success="handleSuccess"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :limit="9"
          :on-exceed="handleExceed"
          :show-file-list="false"
          multiple
        >
          <i class="fa fa-fw fa-cloud-upload color-blue"></i>
          <span size="small" type="primary" class="color-blue">上传文件</span>
        </el-upload>
        <ul>
          <li v-for="(item,index) in files" :key="index" class="text-overflow">
            <el-row>
              <el-col :span="20">
                <div class="grid-content bg-purple text-overflow">
                  <i class="fa fa-fw fa-file"></i>
                  <!-- <a
                    :href="ServerUrl()+item.FileUrl"
                    :download="item.FileName"
                    target="_blank"
                  >{{item.FileName}}</a> -->
                  <span class="color-yellow" @click="downloadFile(ServerUrl()+item.FileUrl)">{{item.FileName}}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light">
                  <i class="fa fa-fw fa-close" @click="deletefile(item)"></i>
                </div>
              </el-col>
            </el-row>
          </li>
        </ul>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "upload",
  data() {
    return {
      upFileUrl: "",
      header: {},
      param: {},
      files: []
    };
  },
  props: {
    data: Object
  },
  methods: {
    drawfilelist() {
      this.apiGeneralFileGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.data.SplitProcessID
        },
        this,
        res => {
          //console.log("文件列表返回", res);
          if (res.code == 20000) {
            this.files = res.data;
          } else {
            this.$toast(res.message);
          }
        }
      );
    },
    //上传进度
    // eslint-disable-next-line
    handleProcess(event, file, fileList) {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传" + file.percentage.toFixed(0) + "%"
      });
    },
    //点击已上传的文件链接时的钩子, 可以通过 file.response 拿到服务端返回数据
    handlePreview() {},
    //文件列表移除文件时的钩子
    handleRemove() {},
    //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeRemove() {},
    //文件超出个数限制时的钩子
    handleExceed() {},
    handleSuccess(response, file, fileList) {
      this.$toast.clear();
      // eslint-disable-next-line
      console.log("文件上传成功返回", response, file, fileList);
      if (response.code == 20000) {
        this.drawfilelist();
      } else {
        // 以弹出框的形式提示异常信息
        this.$dialog
          .alert({ title: "上传文件异常", message: response.message })
          .then(() => {
            // on close
          });
      }
    },
    deletefile(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定删除附件?"
        })
        .then(() => {
          // on confirm
          this.apiGeneralFileDelete(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.data.SplitProcessID,
              FileID: item.FileID
            },
            this,
            res => {
              this.$toast(res.message);
              if (res.code == 20000) {
                this.drawfilelist();
              }
            }
          );
        });
    }
  },
  created() {
    this.upFileUrl = this.getGeneralFileUrl();
    this.header = this.getGeneralFileParam();
    this.param = {
      WorkID: this.getWork().WorkID,
      SplitProcessID: this.data.SplitProcessID
    };
    this.drawfilelist();
  }
};
</script>

<style scoped>
</style>